import * as actions from "../actions/registration";

const customerRegistrationInitialState = {
  customers: null,
  customersListFilter: {
    searchTerm: null,
  },
  activeCustomer: null,
  saveError: null,
};

const customerRegistrationsReducer = (state = customerRegistrationInitialState, action) => {
  switch (action.type) {
    case "RESET_STORE":
      return {
        ...customerRegistrationInitialState,
      };
    case actions.CLEAR_CUSTOMER_REGISTRATIONS:
      return {
        ...customerRegistrationInitialState,
      };
    case actions.UPDATE_CUSTOMER_REGISTRATIONS:
      return {
        ...state,
        customers: action.payload,
        requiresRefresh: false,
      };
    case actions.UPDATE_CUSTOMER_REGISTRATION_LIST_FILTER:
      return {
        ...state,
        customersListFilter: {
          ...state.customersListFilter,
          [action.payload.filterKey]: action.payload.filterValue,
        },
      };
    case actions.CLEAR_CUSTOMER_REGISTRATION_LIST_FILTER:
      return {
        ...state,
        customersListFilter: customerRegistrationInitialState.customersListFilter,
      };
    case actions.UPDATE_CUSTOMER_REGISTRATION_DETAILS:
      return {
        ...state,
        activeCustomer: {
          ...(state.activeCustomer ? state.activeCustomer : {}),
          ...action.payload.customerRegistrationDetails,
        },
      };
    case actions.CLEAR_CUSTOMER_REGISTRATION_DETAILS:
    case actions.CLEAR_ACTIVE_CUSTOMER:
      return {
        ...state,
        activeCustomer: null,
      };
    case actions.UPDATE_CREATE_CUSTOMER:
      if (action.payload.customer) {
        let nextState = { ...state };
        delete nextState.newCustomerErrors;
        return {
          ...nextState,
          activeCustomer: null,
          savingCustomer: false,
          saveError: null,
        };
      } else {
        return {
          ...state,
          newCustomerErrors: action.payload.error,
          activeCustomer: null,
          savingCustomer: false,
          saveError: null,
        };
      }
    case actions.UPDATE_ERROR_CREATE_CUSTOMER:
      return {
        ...state,
        saveError: action.payload.error,
      };
    default:
      return state;
  }
};

export default customerRegistrationsReducer;
